import { Flex, Text } from '@chakra-ui/react';
import { faBars } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ButtonText,
  Menu,
  MenuButton,
  MenuItem,
  MenuList
} from '@morressier/alembic';

const JournalActionMenu = ({
  journalId,
  handleClick,
}: {
    journalId: string;
  handleClick: (journalId: string) => void;
}) => {
  return (
    <Menu ariaLabel="normal menu">
      <MenuButton>
        <ButtonText>
          <Flex gap={2} alignItems="center">
            <FontAwesomeIcon size="lg" icon={faBars} />
          </Flex>
        </ButtonText>
      </MenuButton>

      <MenuList>
        <MenuItem ariaLabel={'View Submission'} onClick={() =>handleClick(journalId)}>
          <Text textStyle="context">View Submissions</Text>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default JournalActionMenu;
